var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 321 320",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-357,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "matrix(0.3125,0,0,0.16,21.7447,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1074,
    y: 0,
    width: 1024,
    height: 2000,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.2,0,0,6.25,786.222,-6500)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 1100,
    width: 300,
    height: 200,
    style: {
      fill: "none",
      stroke: "rgb(51,51,51)",
      strokeWidth: "15.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,1100L250,1200L400,1100L400,1300L320,1160",
    style: {
      fill: "none",
      stroke: "rgb(51,51,51)",
      strokeWidth: "15.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,1160L99.861,1300",
    style: {
      fill: "none",
      stroke: "rgb(51,51,51)",
      strokeWidth: "15.03px"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c5bd96b3ec65b523a9a6c67377ddfd39.svg";
export { ForwardRef as ReactComponent };